import { render, staticRenderFns } from "./CoolButton.vue?vue&type=template&id=a312c83e&scoped=true"
import script from "./CoolButton.vue?vue&type=script&lang=js"
export * from "./CoolButton.vue?vue&type=script&lang=js"
import style0 from "./CoolButton.vue?vue&type=style&index=0&id=a312c83e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a312c83e",
  null
  
)

export default component.exports